export default __webpack_public_path__ + "static/media/repeat.96031172.svg";